import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="p-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Introduction</h2>
      <p className="mb-4">
        This Privacy Policy explains how we collect, use, and protect your
        information when you use our application. By using the app, you agree
        to the terms described in this policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Information We Collect</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Personal information such as name, email, and phone number (if provided).</li>
        <li>Usage data including actions performed inside the app.</li>
        <li>Device information such as model, OS version, and IP address.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. How We Use Your Information</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>To operate and improve the app features.</li>
        <li>To provide support and respond to user queries.</li>
        <li>To enhance security and prevent fraudulent activity.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Sharing</h2>
      <p className="mb-4">
        We do not sell or rent your personal information. Data may be shared only with:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Service providers helping us operate the app.</li>
        <li>Authorities if required for legal compliance.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Data Security</h2>
      <p className="mb-4">
        We use industry-standard security practices to keep your data protected.
        However, no online platform can guarantee complete security.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Children’s Privacy</h2>
      <p className="mb-4">
        This app is not intended for children under 13. We do not knowingly
        collect information from children.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy occasionally. Continued use of the app
        means you accept the changes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, contact us at:
        <br />
        <strong>support@example.com</strong>
      </p>
    </div>
  );
}